// extracted by mini-css-extract-plugin
export default {"component":"Checkbox_component__giBwu","disabled":"Checkbox_disabled__VRJ8B"};